import React, { useContext } from 'react'
import { Box, Button, Container, Flex, HStack, Menu, Portal } from '@chakra-ui/react'
import { UserContext } from '../auth/user-context'
import { AppLink } from './app-link'

type Props = {
    onLogout?: () => void
}

export const MainMenu = ({ onLogout }: Props) => {
    const user = useContext(UserContext)

    return (
        <Box bg="gray.900" color="white" borderBottomWidth="1px" borderColor="whiteAlpha.200">
            <Container maxW="container.xl">
                <Flex h="64px" align="center" justify="space-between">
                    <HStack gap={8}>
                        <AppLink
                            to="/"
                            fontWeight="bold"
                            fontSize="lg"
                            _hover={{ textDecoration: 'none', color: 'blue.300' }}
                        >
                            PR0BE
                        </AppLink>

                        <HStack gap={5}>
                            <AppLink to="/" _hover={{ textDecoration: 'none', color: 'blue.300' }}>
                                Home
                            </AppLink>

                            <AppLink
                                to="/probe"
                                _hover={{ textDecoration: 'none', color: 'blue.300' }}
                            >
                                Probe
                            </AppLink>
                            <AppLink
                                to="/map"
                                _hover={{ textDecoration: 'none', color: 'blue.300' }}
                            >
                                Map
                            </AppLink>
                        </HStack>
                    </HStack>

                    <Menu.Root>
                        <Menu.Trigger asChild>
                            <Button variant="outline" size="sm" colorPalette="gray">
                                {user.name}
                            </Button>
                        </Menu.Trigger>

                        <Portal>
                            <Menu.Positioner>
                                <Menu.Content>
                                    <Menu.Item value="logout" onClick={onLogout}>
                                        Logout
                                    </Menu.Item>
                                </Menu.Content>
                            </Menu.Positioner>
                        </Portal>
                    </Menu.Root>
                </Flex>
            </Container>
        </Box>
    )
}
